import React from 'react';

import "./Months.scss";
import { csInflect } from '@randajan/cs-inflect';


export const Months = (props)=>{
    const { count } = props;
    
    return <span className="Months">{csInflect("# měsíc[e||e|ů]", count)}</span>;
}

